import { render, staticRenderFns } from "./ModificarGeocerca.vue?vue&type=template&id=2021a9f4&scoped=true"
import script from "./ModificarGeocerca.vue?vue&type=script&setup=true&lang=js"
export * from "./ModificarGeocerca.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ModificarGeocerca.vue?vue&type=style&index=0&id=2021a9f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2021a9f4",
  null
  
)

export default component.exports